import { render, staticRenderFns } from "./AppRevshare.vue?vue&type=template&id=2fa89d48"
import script from "./AppRevshare.vue?vue&type=script&lang=js"
export * from "./AppRevshare.vue?vue&type=script&lang=js"
import style0 from "./AppRevshare.vue?vue&type=style&index=0&id=2fa89d48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports